/**
 * chat/chatTokens.js — palette + spacing tokens for the ticket
 * conversation redesign (Mint / Variant B). Kept in one place so a
 * designer can tune the whole chat theme by editing this file only.
 *
 * See /tmp/TZ2/ticket-chat-redesign-spec.md for the full spec.
 */

export const CHAT_TOKENS = {
  // Zone
  chatBg: '#f2f5f3',              // whole conversation background (muted grey-mint)
  // Bubbles
  ownBg: '#d9f2e6',               // "мой" pill — soft mint
  otherBg: '#ffffff',             // customer / other side — white
  otherBorder: '#e5e7eb',         // subtle border on white bubble
  text: '#1f2937',                // primary text inside bubble (dark grey)
  meta: '#6b7280',                // time / status inside bubble
  metaFaint: '#9ca3af',           // "sent" (delivered, not read) checks
  readActive: '#059669',          // ✓✓ read — muted green
  authorOwn: '#047857',           // author name above own bubble
  authorOther: '#7c3aed',         // author name above customer bubble
  dividerBg: 'rgba(255,255,255,0.7)',
  dividerText: '#6b7280',
  // Attachment card
  attBg: '#ffffff',
  attBorder: '#e5e7eb',
  attBorderHover: '#d1d5db',
  badgeWarnBg: '#fef3c7',
  badgeWarnText: '#92400e',
  badgeOkBg: '#dcfce7',
  badgeOkText: '#166534',
  // File type badges
  iconZipBg: '#dbeafe', iconZipText: '#1e40af',
  iconPdfBg: '#fee2e2', iconPdfText: '#b91c1c',
  iconNeutralBg: '#f3f4f6', iconNeutralText: '#374151',
};

// Author-series compression window: same-author messages within this
// window skip the author label to reduce visual noise (spec §66-70).
export const AUTHOR_SERIES_GAP_MINUTES = 5;
